import { API_BASE } from "../../auth/http"
export const BASE = `${API_BASE}/api/acompanhamento-equipamentos`
export async function api(caminho = "", metodo = "GET", dados, signal) {
  const resposta = await fetch(`${BASE}${caminho}`, {
    method: metodo, signal,
    ...(dados !== undefined && { headers: { "Content-Type": "application/json" }, body: JSON.stringify(dados) })
  })
  const resultado = await resposta.json()
  if (!resposta.ok || !resultado.sucesso) throw new Error(resultado.erro || "Não foi possível concluir a operação")
  return resultado.dados
}
export const dataBR = valor => valor ? valor.slice(0, 10).split("-").reverse().join("/") : "—"
export async function baixarAnalise(filtros, tipo, formato) {
  const params = new URLSearchParams(Object.entries({ ...filtros, tipo, formato }).filter(([, v]) => v !== "" && v != null && v !== undefined))
  const resposta = await fetch(`${BASE}/analise/exportar?${params}`)
  if (!resposta.ok) {
    const erro = await resposta.json().catch(() => ({}))
    throw new Error(erro.erro || "Não foi possível exportar a análise")
  }
  const url = URL.createObjectURL(await resposta.blob())
  const link = document.createElement("a")
  link.href = url
  link.download = resposta.headers.get("Content-Disposition")?.match(/filename="([^"]+)"/)?.[1] || `analise_equipamentos.${formato}`
  document.body.appendChild(link); link.click(); link.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
export const hoje = () => {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`
}
export const vazio = obraId => ({ responsavel: "", situacao: "Ativo", local_tipo: "CANTEIRO", local_obra_id: obraId || "", id_fornecedor: "", localizacao: "", observacao: "" })
export const COLUNAS = ["DATA", "CÓD EQUIP.", "PLACA", "DESCRIÇÃO DO EQUIPAMENTO", "CONDUTOR / OPERADOR / PROPRIETÁRIO", "ÁREA", "SITUAÇÃO", "LOCALIZAÇÃO"]
export const CAMPOS = { responsavel: "Responsável", situacao: "Situação", localizacao: "Localização", observacao: "Observação" }
export function nomeLocalizacao(valor) {
  if (valor.dados_origem && valor.localizacao === valor.dados_origem.localizacao) return valor.localizacao || "—"
  if (valor.local_tipo === "CANTEIRO") return "Canteiro"
  if (valor.local_tipo === "TRECHO") return valor.localizacao && valor.localizacao.toUpperCase() !== "TRECHO" ? `Trecho — ${valor.localizacao}` : "Trecho"
  if (valor.local_tipo === "OFICINA") return valor.localizacao ? `Oficina — ${valor.localizacao}` : "Oficina"
  return valor.localizacao || "—"
}

export async function enviarPlanilha(arquivo, obraId) {
  if (!obraId) throw new Error("Selecione a obra de destino antes de iniciar a importação")
  const resposta = await fetch(`${BASE}/importacoes/analisar?${new URLSearchParams({ arquivo: arquivo.name, obraId })}`, { method: "POST", headers: { "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }, body: arquivo })
  const resultado = await resposta.json()
  if (!resposta.ok || !resultado.sucesso) throw new Error(resultado.erro || "Não foi possível analisar a planilha")
  return resultado.dados
}
export async function confirmarImportacao(id, dados, progresso) {
  const resposta=await fetch(`${BASE}/importacoes/${id}/confirmar?progresso=1`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(dados)})
  if(!resposta.ok){const erro=await resposta.json().catch(()=>({}));throw new Error(erro.erro || `Falha HTTP ${resposta.status} ao confirmar a importação`)}
  const leitor=resposta.body.getReader(),decoder=new TextDecoder()
  let restante="",resultado
  const tratar=texto=>{
    if(!texto.trim())return
    const evento=JSON.parse(texto)
    if(evento.tipo==="erro")throw new Error(evento.erro)
    if(evento.tipo==="progresso")progresso(evento)
    if(evento.tipo==="resultado")resultado=evento.dados
  }
  try {
    while(true){
      const {done,value}=await leitor.read()
      restante+=decoder.decode(value,{stream:!done})
      const linhas=restante.split("\n");restante=linhas.pop()
      for(const linha of linhas)tratar(linha)
      if(done)break
    }
    tratar(restante)
    if(!resultado)throw new Error("Conexão interrompida antes do resultado final. Consulte a análise salva para verificar se a importação foi concluída antes de tentar novamente")
    return resultado
  } finally {leitor.releaseLock()}
}
export async function baixarImportacao(id, formato = "csv") {
  const resposta = await fetch(`${BASE}/importacoes/${id}/${formato === "csv" ? "relatorio.csv" : "fonte"}`)
  if (!resposta.ok) throw new Error("Não foi possível baixar o relatório")
  const url = URL.createObjectURL(await resposta.blob())
  const link = document.createElement("a")
  link.href = url; link.download = formato === "csv" ? "relatorio-importacao.csv" : "fonte-importacao.json"
  document.body.appendChild(link); link.click(); link.remove(); URL.revokeObjectURL(url)
}
export function alteracaoSituacao(valor, situacao) {
  return { situacao, ...(valor.local_tipo === "OFICINA" && situacao !== "Manutenção" && { local_tipo: "", local_obra_id: "", id_fornecedor: "", localizacao: "" }) }
}
export function validarFormulario(valor, opcoes, { situacaoIndefinida = false, validarReferencia = true, localizacaoLegada = false } = {}) {
  if (!situacaoIndefinida && !["Ativo", "Stand-by", "Manutenção"].includes(valor.situacao)) throw new Error("Selecione uma situação válida")
  if (localizacaoLegada && valor.local_tipo === "TRECHO") return
  if (!valor.local_tipo) return
  if (!["CANTEIRO", "OFICINA", "TRECHO"].includes(valor.local_tipo)) throw new Error("Selecione uma localiza\u00e7\u00e3o")
  if (valor.local_tipo === "TRECHO" && !String(valor.localizacao || "").trim()) throw new Error("Informe o trecho")
  if (valor.local_tipo === "OFICINA") {
    if (!situacaoIndefinida && valor.situacao !== "Manutenção") throw new Error("Oficina é permitida somente em Manutenção")
    if (!valor.id_fornecedor || (validarReferencia && !opcoes.oficinas.some(o => String(o.id_fornecedor) === String(valor.id_fornecedor)))) throw new Error("Selecione uma oficina válida nas sugestões")
  }
  if (valor.local_tipo === "CANTEIRO" && (!valor.local_obra_id || (validarReferencia && !opcoes.canteiros.some(o => String(o.cod_almoxarifado) === String(valor.local_obra_id))))) throw new Error("Selecione um canteiro válido")
}
